import React from "react";
import { Link } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";
import { auth } from "@/lib/api";

/** Friendly 403 shown when a signed-in user hits a route they don't have
 *  the required `hsp:*` permission for. */
export default function AccessDenied({ permission }) {
  const me = auth.me();
  return (
    <div
      data-testid="access-denied-page"
      className="min-h-screen flex items-center justify-center bg-slate-50 px-6"
    >
      <div className="w-full max-w-md rounded-md border border-slate-200 bg-white p-8 shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
          <ShieldAlert size={22} className="text-amber-700" strokeWidth={2.5} />
        </div>
        <div className="text-center">
          <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-amber-700">
            403 · Access denied
          </div>
          <h1 className="mt-1 font-heading text-2xl font-bold tracking-tight text-slate-900">
            You don't have permission to see this
          </h1>
          <p className="mt-2 text-sm text-slate-600">
            Signed in as <b>{me?.display_name || "unknown"}</b>
            {me?.role && (
              <>
                {" "}with role <b>{me.role.replace("_", " ")}</b>
              </>
            )}
            .
          </p>
          {permission && (
            <div className="mt-3 rounded-md border border-slate-200 bg-slate-50 p-2.5 text-left">
              <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500">
                Missing permission
              </div>
              <code className="mt-0.5 block break-all text-xs font-mono text-slate-800">
                {permission}
              </code>
            </div>
          )}
          <p className="mt-4 text-xs text-slate-500">
            Ask a super-admin to grant this permission from the Users → Web tab,
            then reload the page.
          </p>
          <Link
            to="/"
            data-testid="access-denied-home-link"
            className="mt-6 inline-flex items-center gap-1.5 rounded-md bg-nmi-700 px-4 py-2 text-xs font-semibold text-white hover:bg-nmi-800"
          >
            <ArrowLeft size={12} strokeWidth={2.5} /> Back to Facilities
          </Link>
        </div>
      </div>
    </div>
  );
}
